export default __webpack_public_path__ + "static/media/refillPlanIcon.b4c5ab20.svg";